export default {
    setCollege(state, data) {
        state.college = data
    },
    setSubMajor(state, subMajor) {
        state.subMajor = subMajor
    },
}